var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.532,
    height: 12.355,
    viewBox: "0 0 18.532 12.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M9.048,8.266,5.919,5.7.72,10.63H17.442L12.215,5.674Z",
    transform: "translate(0.219 1.726)",
    fill: "#e4001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M10.278,6.046,15.406,10.9V1.85Z",
    transform: "translate(3.126 0.563)",
    fill: "#e4001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M0,10.971l5.168-4.9L0,1.851Z",
    transform: "translate(0 0.563)",
    fill: "#e4001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M0,0V.792L9.266,8.369,18.532.792V0Z",
    transform: "translate(0 0)",
    fill: "#e4001b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.f74ac079f6f0dd4425507a4ce510d2f2.svg";
export { ForwardRef as ReactComponent };